/**
 * The words on the auth screens, in one place.
 *
 * There are two places someone can sign in now: the dialog that opens over the
 * directory, and the dedicated /login page for people arriving from an email or
 * a shared link. Both are Caren's copy, and copy that exists twice drifts:
 * someone edits the modal, the page keeps the old line, and the two screens
 * start describing different products.
 *
 * These are the strings that appear on both. Anything genuinely specific to one
 * screen stays in that component.
 */

import { PUBLISHED_TOOL_COUNT } from "./toolsData";

/**
 * What the account actually gives you.
 *
 * Written for someone who has just answered two questions and is one click from
 * a specific answer, so the first line names the thing they are about to see
 * rather than describing the product. The originals are in git history at
 * 20af4e2 if they are ever wanted back.
 */
export const AUTH_BULLETS = [
  "Your matched tools, and why each one fits",
  "A step-by-step path for each, in order",
  "Your progress saved on anything you start",
  `The full database of ${PUBLISHED_TOOL_COUNT} tools`,
] as const;

/** Carried over from the Manus AuthPage verbatim. Do not reword. */
export const AUTH_PRIVACY_LINE =
  "We respect your privacy. Your data is secure and will never be shared.";

/** Headings for each mode, shared by the dialog and the page. */
export const AUTH_COPY = {
  signup: {
    title: "Your stack is ready.",
    description:
      "Create a free account to see your tools. Anything you open or work through is saved to your stack. No card.",
    formHeading: "Create your free account",
    formSubheading: "Instant access to the AI tools database.",
  },
  login: {
    title: "Welcome back",
    description:
      "Sign in to pick up where you left off, or create a free account.",
    formHeading: "Sign in to your account",
    formSubheading: "Your stack and your progress are waiting.",
  },
} as const;
